import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { useAuthStore } from './lib/auth';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Keep data fresh-ish but avoid hammering the API on every focus.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

// Kick off the auth bootstrap (token-from-storage → /me) in parallel with
// React's first paint. The router shows a neutral "Loading…" state while
// `isBootstrapping` is true, so we never render protected routes against
// stale auth state.
void useAuthStore.getState().bootstrap();

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* basename comes from Vite's `base` (import.meta.env.BASE_URL) so the
          same source works at root in dev and under /app-next (or /app) in
          production. Trailing slash stripped — React Router wants none. */}
      <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
